<template>
  <div>
    <div ref="chartdiv" class="country" />
  </div>
</template>

<script>
import * as am4core from '@amcharts/amcharts4/core';
import * as am4maps from '@amcharts/amcharts4/maps';
import am4geoDataBrazilLow from '@amcharts/amcharts4-geodata/brazilLow';

export default {
  name: 'Country',
  props: {
    handleSelectState: {
      type: Function,
      required: true,
    },
    statesMap: {
      type: Array,
      required: true,
    },
    selectedStates: {
      type: Array,
      required: true,
    },
    hoverStateColor: {
      type: String,
      required: false,
      default: '#003036',
    },
    applySelectedState: {
      type: Boolean,
      required: false,
      default: false,
    },
    selectBoxTrigger: {
      type: Array,
      required: false,
      default: () => [],
    },
  },
  data: () => ({
    chart: null,
    polygonSeries: null,
  }),
  computed: {
    formattedStatesMap() {
      return this.statesMap.map(state => ({
        ...state,
        color: am4core.color(state.color),
      }));
    },
  },
  watch: {
    selectBoxTrigger() {
      // this.validForms();
    },
    selectedStates() {
      this.polygonSeries.mapPolygons.values.forEach(value => {
        if (
          this.selectedStates.find(
            state => state.id === value.dataItem.dataContext.id,
          ) != null
        ) {
          value.isActive = true;
        } else {
          value.isActive = false;
        }
      });
    },
  },
  async mounted() {
    this.chart = am4core.create(this.$refs.chartdiv, am4maps.MapChart);
    this.chart.geodata = am4geoDataBrazilLow;

    this.chart.projection = new am4maps.projections.Miller();
    this.chart.chartContainer.wheelable = false;
    this.chart.seriesContainer.draggable = false;
    this.chart.seriesContainer.resizable = false;
    this.chart.maxZoomLevel = 1;

    this.polygonSeries = this.chart.series.push(new am4maps.MapPolygonSeries());

    // Make map load polygon (like country names) data from GeoJSON
    this.polygonSeries.useGeodata = true;

    this.polygonSeries.data = [...this.formattedStatesMap];

    // Configure series
    const polygonTemplate = this.polygonSeries.mapPolygons.template;

    // If Prop "applySelectedState" is true create selected state and set alternative fill color and create an event to toggle "active" state
    if (this.applySelectedState) {
      const activeState = polygonTemplate.states.create('active');
      activeState.properties.fill = am4core.color(this.hoverStateColor);
      polygonTemplate.tooltipText = false;

      polygonTemplate.events.on('hit', ev => {
        ev.target.isActive = !ev.target.isActive;
      });
      polygonTemplate.events.on('hit', this.selectState);

      // if (this.selectBoxTrigger) {

      // }
    } else {
      polygonTemplate.tooltipText = '{name}';
      // polygonTemplate.fill = am4core.color('#26d07c');
      // polygonTemplate.propertyFields.fill = 'color';
      polygonTemplate.events.on('hit', this.selectState);
      polygonTemplate.events.on('hit', this.scrollToDetails);

      // Create hover state and set alternative fill color
      const hs = polygonTemplate.states.create('hover');
      hs.properties.fill = am4core.color(this.hoverStateColor);
    }
  },
  beforeDestroy() {
    this.disposeChart();
  },
  methods: {
    selectState(event) {
      if (this.applySelectedState) {
        this.handleSelectState(event.target.dataItem.dataContext);
      } else {
        this.handleSelectState(event.target.dataItem.dataContext);
      }
    },

    scrollToDetails() {
      this.$vuetify.goTo(
        document.getElementById('details').offsetTop -
          document.getElementById('navbar').offsetHeight,
      );
    },
    disposeChart() {
      this.chart.dispose();
    },
  },
};
</script>

<style lang="sass" scoped>
.country
  width: 100%
  height: 600px
</style>
